export default __webpack_public_path__ + "static/media/logosFooter.ff3ecb31.svg";